import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Policy from "./pages/Policy";
import Pagenotfound from "./pages/Pagenotfound";
import Register from "./pages/Auth/Register";
import Login from "./pages/Auth/Login";
import Dashboard from "./pages/user/Dashboard";
import PrivateRoute from "./components/Routes/Private";
import ForgotPasssword from "./pages/Auth/ForgotPasssword";
import AdminRoute from "./components/Routes/AdminRoute";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import CreateCategory from "./pages/Admin/CreateCategory";
import CreateProduct from "./pages/Admin/CreateProduct";
import Users from "./pages/Admin/Users";
import Orders from "./pages/user/Orders";
import QrCheckoutPage from "./pages/user/QrCheckoutPage";
import OrderConfirmationPage from "./pages/user/OrderConfirmationPage";
import Profile from "./pages/user/Profile";
import AddressForm from "./pages/user/AddressForm";
import DeliveryAddress from "./pages/user/DeliveryAddress";
import Products from "./pages/Admin/Products";
import UpdateProduct from "./pages/Admin/UpdateProduct";
import Search from "./pages/Search";
import ProductDetails from "./pages/ProductDetails";
import Categories from "./pages/Categories";
import CategoryProduct from "./pages/CategoryProduct";
import CartPage from "./pages/CartPage";
import AdminOrders from "./pages/Admin/AdminOrders";
import AdminQrPayments from "./pages/Admin/AdminQrPayments";
import Reports from "./pages/Admin/Reports";
import Discounts from "./pages/Admin/Discounts";
import Integrations from "./pages/Admin/Integrations";
import Help from "./pages/Admin/Help";
import Settings from "./pages/Admin/Settings";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product/:slug" element={<ProductDetails />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/category/:slug" element={<CategoryProduct />} />
        <Route path="/search" element={<Search />} />
        {/* <Route path="/address-update" element={<AddressForm/>}/> */}
        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route path="user" element={<Dashboard />} />
          <Route path="user/orders" element={<Orders />} />
          <Route path="user/checkout/qr/:orderId" element={<QrCheckoutPage />} />
          <Route path="user/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
          <Route path="user/profile" element={<Profile />} />
          <Route path="user/address-update" element={<AddressForm/>}/>
          <Route path="user/delivery-address" element={<DeliveryAddress/>}/>
        </Route>
        <Route path="/dashboard" element={<AdminRoute />}>
          <Route path="admin" element={<AdminDashboard />} />
          <Route path="admin/create-category" element={<CreateCategory />} />
          <Route path="admin/create-product" element={<CreateProduct />} />
          <Route path="admin/product/:slug" element={<UpdateProduct />} />
          <Route path="admin/products" element={<Products />} />
          <Route path="admin/users" element={<Users />} />
          <Route path="admin/orders" element={<AdminOrders />} />
          <Route path="admin/qr-payments" element={<AdminQrPayments />} />
          <Route path="admin/reports" element={<Reports />} />
          <Route path="admin/discounts" element={<Discounts />} />
          <Route path="admin/integrations" element={<Integrations />} />
          <Route path="admin/help" element={<Help />} />
          <Route path="admin/settings" element={<Settings />} />
          <Route path="admin/address-update" element={<AddressForm/>}/>
        </Route>
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPasssword />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="*" element={<Pagenotfound />} />
      </Routes>
    </>
  );
}

export default App;